export type WebinarStatus = 'DRAFT' | 'PUBLISHED'

export const WEBINAR_STATUSES: Readonly<
  { text: string; value: WebinarStatus; default?: boolean }[]
> = [
  { text: 'Draft', value: 'DRAFT', default: true },
  { text: 'Published', value: 'PUBLISHED' },
] as const
